/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdUsersInstructorBusy200,
  GetApiV1ClassroomdisciplineIdUsersInstructorBusy401,
  GetApiV1ClassroomdisciplineIdUsersInstructorBusy404,
  GetApiV1ClassroomdisciplineIdUsersInstructorBusyPathParams,
  GetApiV1ClassroomdisciplineIdUsersInstructorBusyQueryParams,
  GetApiV1ClassroomdisciplineIdUsersInstructorBusyQueryResponse,
} from "../../types/classPlanningPeopleController/GetApiV1ClassroomdisciplineIdUsersInstructorBusy.ts";

export const getApiV1ClassroomdisciplineIdUsersInstructorBusyPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersInstructorBusyPathParams>;

export const getApiV1ClassroomdisciplineIdUsersInstructorBusyQueryParamsSchema =
  z
    .object({
      personId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersInstructorBusyQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdUsersInstructorBusy200Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersInstructorBusy200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdUsersInstructorBusy401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersInstructorBusy401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdUsersInstructorBusy404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersInstructorBusy404>;

export const getApiV1ClassroomdisciplineIdUsersInstructorBusyQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdUsersInstructorBusy200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdUsersInstructorBusyQueryResponse>;
